let events = [];
let clubNews = [];

const metroHomepageEventsRevision = "2026-07-26-homepage-events";

const header = document.querySelector("[data-header]");
const navToggle = document.querySelector(".nav-toggle");
const nav = document.querySelector(".site-nav");
const tickerTrack = document.querySelector(".ticker div");
const splitHeadingSelector = [
  ".section-head h2",
  ".event-detail-copy h1",
  ".article-title",
  ".mr-gallery h1"
].join(",");
const revealImageSelector = [
  ".article-hero__image",
  ".news-card-image",
  ".venue-photo-panel img",
  ".gallery-grid img",
  ".page-media-grid img",
  ".mr-thumb"
].join(",");

function slugify(value) {
  return value
    .toLowerCase()
    .replace(/£/g, "pound")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function eventUrl(event) {
  if (event.productUrl && event.productUrl !== "#") {
    return event.productUrl;
  }

  const baseUrl = window.METRO_EVENT_DETAIL_URL || "/products/";
  return `${baseUrl}${encodeURIComponent(slugify(event.title))}`;
}

function assetUrl(fileName) {
  if (!fileName) return "";
  if (/^https?:\/\//.test(fileName) || fileName.startsWith("/")) return fileName;
  return `${window.METRO_ASSET_BASE || ""}${fileName}`;
}

function cleanEventSummary(summary = "", title = "", maxLength = 150) {
  const normalizedTitle = title.trim();
  const titlePattern = normalizedTitle
    ? new RegExp(normalizedTitle.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "ig")
    : null;

  let cleaned = String(summary)
    .replace(/<br\s*\/?>/gi, ". ")
    .replace(/<\/p>/gi, ". ")
    .replace(/<[^>]+>/g, " ")
    .replace(/metro\s+reloaded\s+presents/gi, " ")
    .replace(/\bpresents\b/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (titlePattern) {
    cleaned = cleaned.replace(titlePattern, "").replace(/\s+/g, " ").trim();
  }

  if (!cleaned) return "";
  if (cleaned.length <= maxLength) return cleaned;

  return `${cleaned.slice(0, maxLength).replace(/\s+\S*$/, "")}...`;
}

function escapeHtml(value = "") {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function formatNewsDate(value) {
  if (!value) return "Latest";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Latest";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric"
  });
}

function parseNewsTimestamp(value) {
  const timestamp = value ? Date.parse(value) : 0;
  return Number.isNaN(timestamp) ? 0 : timestamp;
}

function metroTrack(eventName, payload = {}) {
  const eventPayload = {
    page_location: window.location.href,
    page_title: document.title,
    ...payload
  };

  window.Shopify?.analytics?.publish?.(eventName, eventPayload);

  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, eventPayload);
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...eventPayload
  });
}

function setupCommerceTracking(root = document) {
  root.querySelectorAll("[data-metro-ticket-click]").forEach((link) => {
    if (link.dataset.metroTrackingReady === "true") return;
    link.dataset.metroTrackingReady = "true";

    link.addEventListener("click", () => {
      metroTrack("click_ticket_link", {
        event_title: link.dataset.eventTitle || document.title,
        ticket_provider: link.dataset.ticketProvider || new URL(link.href, window.location.href).hostname,
        link_url: link.href
      });
    });
  });

  root.querySelectorAll("[data-metro-lead-form]").forEach((form) => {
    if (form.dataset.metroTrackingReady === "true") return;
    form.dataset.metroTrackingReady = "true";

    form.addEventListener("submit", () => {
      const enquiryType = form.querySelector("[name='contact[enquiry_type]']")?.value || form.dataset.metroLeadForm;
      metroTrack("generate_lead", {
        form_name: form.dataset.metroLeadForm || "contact",
        enquiry_type: enquiryType
      });
    });
  });

  root.querySelectorAll("[data-metro-signup-form]").forEach((form) => {
    if (form.dataset.metroTrackingReady === "true") return;
    form.dataset.metroTrackingReady = "true";

    form.addEventListener("submit", () => {
      metroTrack("sign_up", {
        method: form.dataset.metroSignupForm || "newsletter"
      });
    });
  });
}

function splitHeadingText(heading) {
  const text = heading.textContent.trim().replace(/\s+/g, " ");
  if (!text || heading.dataset.metroSplit === "true") return;

  let charIndex = 0;
  const words = text.split(" ").map((word) => {
    const chars = [...word].map((char) => {
      const span = `<span class="split-char" style="--char-index: ${charIndex};">${char}</span>`;
      charIndex += 1;
      return span;
    }).join("");

    return `<span class="split-word">${chars}</span>`;
  });

  heading.dataset.metroSplit = "true";
  heading.classList.add("split-heading");
  heading.setAttribute("aria-label", text);
  heading.innerHTML = words.join(" ");
}

function setupSplitHeadings(root = document) {
  const headings = root.querySelectorAll(splitHeadingSelector);
  if (!headings.length) return;

  headings.forEach(splitHeadingText);

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    headings.forEach((heading) => heading.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    });
  }, { rootMargin: "0px 0px -10% 0px", threshold: 0.2 });

  headings.forEach((heading) => observer.observe(heading));
}

function setupImageReveals(root = document) {
  const images = root.querySelectorAll(revealImageSelector);
  if (!images.length) return;
  const armedImages = [];

  images.forEach((image, index) => {
    if (image.dataset.metroImageReveal === "true") return;
    image.dataset.metroImageReveal = "true";
    image.classList.add("image-reveal", "is-armed");
    image.style.setProperty("--image-index", Math.min(index % 6, 5));
    armedImages.push(image);
  });

  if (!armedImages.length) return;

  if (
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    !("IntersectionObserver" in window)
  ) {
    armedImages.forEach((image) => image.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    });
  }, { rootMargin: "0px 0px -12% 0px", threshold: 0.18 });

  armedImages.forEach((image) => observer.observe(image));

  window.setTimeout(() => {
    armedImages.forEach((image) => image.classList.add("is-visible"));
  }, 1800);
}

function setupShareButtons(root = document) {
  const shareIcons = {
    facebook: "<svg viewBox=\"0 0 32 32\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M20.6 17.9h3.7l.6-4.5h-4.3v-2.9c0-1.3.4-2.2 2.3-2.2H25v-4c-.4-.1-1.8-.2-3.5-.2-3.5 0-5.9 2.1-5.9 6v3.3h-4v4.5h4v10.7h5V17.9Z\"/></svg>",
    x: "<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M17.8 3h3.1l-6.8 7.8L22 21h-6.2l-4.9-6.4L5.4 21H2.2l7.3-8.4L2 3h6.4l4.4 5.8L17.8 3Zm-1.1 16.2h1.7L7.5 4.7H5.7l11 14.5Z\"/></svg>",
    whatsapp: "<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M19.1 4.9A9.9 9.9 0 0 0 3.5 16.8L2 22l5.4-1.4A9.9 9.9 0 0 0 22 12a9.8 9.8 0 0 0-2.9-7.1Zm-7 15.3a8.2 8.2 0 0 1-4.2-1.1l-.3-.2-3.2.8.9-3.1-.2-.3A8.2 8.2 0 1 1 20.3 12a8.2 8.2 0 0 1-8.2 8.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.6.1a6.6 6.6 0 0 1-1.9-1.2 7 7 0 0 1-1.3-1.6c-.1-.3 0-.4.1-.6l.4-.4c.1-.1.2-.3.3-.5.1-.2 0-.3 0-.5l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.2-1 1-1 2.3 0 1.4 1 2.7 1.1 2.9.1.2 2 3.1 4.8 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3Z\"/></svg>",
    email: "<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm17 3.2-7.4 5.4a1 1 0 0 1-1.2 0L4 8.2V17h16V8.2ZM5.5 7l6.5 4.7L18.5 7h-13Z\"/></svg>",
    copy: "<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M8.5 7A4.5 4.5 0 0 1 13 2.5h3A4.5 4.5 0 0 1 20.5 7v3a4.5 4.5 0 0 1-4.5 4.5h-2v-2h2A2.5 2.5 0 0 0 18.5 10V7A2.5 2.5 0 0 0 16 4.5h-3A2.5 2.5 0 0 0 10.5 7v2h-2V7Zm1 4h5v2h-5v-2ZM3.5 14A4.5 4.5 0 0 1 8 9.5h2v2H8A2.5 2.5 0 0 0 5.5 14v3A2.5 2.5 0 0 0 8 19.5h3A2.5 2.5 0 0 0 13.5 17v-2h2v2a4.5 4.5 0 0 1-4.5 4.5H8A4.5 4.5 0 0 1 3.5 17v-3Z\"/></svg>"
  };

  root.querySelectorAll(".social-share__button").forEach((button) => {
    const label = button.getAttribute("aria-label") || "";
    const labelText = label || button.textContent.trim();
    const lowerLabel = labelText.toLowerCase();
    let icon = "";

    if (lowerLabel.includes("facebook")) {
      icon = shareIcons.facebook;
      button.classList.add("social-share__button--facebook");
      button.setAttribute("data-share-popup", "");
      button.dataset.tooltip ||= "Facebook";
      button.title ||= "Share on Facebook";
    } else if (lowerLabel.includes("x")) {
      icon = shareIcons.x;
      button.classList.add("social-share__button--x");
      button.setAttribute("data-share-popup", "");
      button.dataset.tooltip ||= "X";
      button.title ||= "Share on X";
      if (button.href) button.href = button.href.replace("https://twitter.com/intent/tweet", "https://x.com/intent/tweet");
    } else if (lowerLabel.includes("whatsapp")) {
      icon = shareIcons.whatsapp;
      button.classList.add("social-share__button--whatsapp");
      button.dataset.tooltip ||= "WhatsApp";
      button.title ||= "Share on WhatsApp";
      if (button.href?.startsWith("https://api.whatsapp.com/send?text=")) {
        button.href = button.href.replace("https://api.whatsapp.com/send?text=", "https://wa.me/?text=");
      }
    } else if (lowerLabel.includes("email")) {
      icon = shareIcons.email;
      button.classList.add("social-share__button--email");
      button.dataset.tooltip ||= "Email";
      button.title ||= "Share by email";
    } else if (button.matches("[data-share-copy]")) {
      icon = shareIcons.copy;
      button.dataset.tooltip ||= "Copy link";
      button.title ||= "Copy page link";
    }

    if (icon && !button.querySelector("svg")) {
      button.innerHTML = `${icon}<span class="sr-only">${labelText}</span>`;
    }
  });

  const copyButtons = root.querySelectorAll("[data-share-copy]");
  const popupLinks = root.querySelectorAll("[data-share-popup]");

  copyButtons.forEach((button) => {
    if (button.dataset.metroShareReady === "true") return;
    button.dataset.metroShareReady = "true";

    button.addEventListener("click", async () => {
      const shareUrl = button.dataset.shareCopy;

      try {
        await navigator.clipboard.writeText(shareUrl);
        button.setAttribute("aria-label", "Page link copied");
        button.classList.add("is-copied");
        window.setTimeout(() => {
          button.setAttribute("aria-label", "Copy page link");
          button.classList.remove("is-copied");
        }, 1800);
      } catch (error) {
        window.prompt("Copy this link", shareUrl);
      }
    });
  });

  popupLinks.forEach((link) => {
    if (link.dataset.metroSharePopupReady === "true") return;
    link.dataset.metroSharePopupReady = "true";

    link.addEventListener("click", (event) => {
      const width = 640;
      const height = 520;
      const left = Math.max(0, Math.round((window.screen.width - width) / 2));
      const top = Math.max(0, Math.round((window.screen.height - height) / 2));
      const popup = window.open(
        link.href,
        "metro-share",
        `popup=yes,noopener=yes,noreferrer=yes,scrollbars=yes,resizable=yes,width=${width},height=${height},left=${left},top=${top}`
      );

      if (!popup) return;
      event.preventDefault();
      popup.focus();
    });
  });
}

function posterMarkup(event) {
  if (event.image) {
    return `<img class="event-poster" src="${assetUrl(event.image)}" alt="${event.title} poster" loading="lazy">`;
  }

  return `
    <div class="event-poster event-poster-empty" aria-hidden="true">
      <span>Metro Reloaded</span>
    </div>
  `;
}

function parseEventDate(value) {
  if (!value) return Number.MAX_SAFE_INTEGER;

  const normalized = String(value)
    .trim()
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/(\d+)(st|nd|rd|th)/g, "$1")
    .replace(/sept(?!ember)/g, "sep")
    .replace(/\s+/g, " ");
  const parts = normalized.match(/(\d{1,2})\s+([a-z]{3,9})(?:\s+(\d{2,4}))?/);
  if (!parts) return Number.MAX_SAFE_INTEGER;

  const months = {
    jan: 0, january: 0, feb: 1, february: 1, mar: 2, march: 2,
    apr: 3, april: 3, may: 4, jun: 5, june: 5, jul: 6, july: 6,
    aug: 7, august: 7, sep: 8, september: 8, oct: 9, october: 9,
    nov: 10, november: 10, dec: 11, december: 11
  };

  const day = Number(parts[1]);
  const month = months[parts[2]];
  let year = parts[3] ? Number(parts[3]) : new Date().getFullYear();
  if (year < 100) year += 2000;

  if (!day || month === undefined || !year) return Number.MAX_SAFE_INTEGER;
  return new Date(year, month, day).getTime();
}

function formatEventDate(value) {
  const timestamp = parseEventDate(value);
  if (timestamp === Number.MAX_SAFE_INTEGER) return value || "Date TBC";

  const date = new Date(timestamp);
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const day = date.getDate();
  const year = String(date.getFullYear()).slice(-2);

  return `${weekdays[date.getDay()]} ${day} ${months[date.getMonth()]} '${year}`;
}

function setupEventDateDisplays(root = document) {
  const dateTargets = root.querySelectorAll([
    ".event-date span:first-child",
    ".whats-on-card__body > span:first-child",
    ".event-info-aside div:first-child strong",
    ".detail-grid article:first-child strong"
  ].join(","));

  dateTargets.forEach((target) => {
    if (target.dataset.metroDateFormatted === "true") return;

    const currentDate = target.textContent.trim();
    const formattedDate = formatEventDate(currentDate);
    if (!formattedDate || formattedDate === currentDate) return;

    target.textContent = formattedDate;
    target.dataset.metroDateFormatted = "true";
  });
}

function isPastEvent(event) {
  const eventStart = parseEventDate(event?.date);
  if (eventStart === Number.MAX_SAFE_INTEGER) return false;

  const eventEnd = eventStart + (24 * 60 * 60 * 1000) - 1;
  return eventEnd < Date.now();
}

function upcomingEventsList() {
  return [...events]
    .filter((event) => !isPastEvent(event))
    .sort((a, b) => parseEventDate(a.date) - parseEventDate(b.date));
}

function eventCard(event, index = 0) {
  const summary = cleanEventSummary(event.summary, event.title, 135);
  const displayDate = formatEventDate(event.date);

  return `
    <article class="event-card" data-category="${event.category}" data-event-date="${event.date}" data-event-index="${index}">
      <a href="${eventUrl(event)}" aria-label="View ${event.title}">
        ${posterMarkup(event)}
      </a>
      <div>
        <div class="event-date">
          <span>${displayDate}</span>
          <span>${event.category}</span>
        </div>
        <h3 class="event-title">
          <a href="${eventUrl(event)}">${event.title}</a>
        </h3>
        <p class="event-meta">${event.time}<br>${event.venue}<br>${summary}</p>
      </div>
      <div class="event-footer">
        <span class="event-price">${event.price}</span>
        <a class="button button-ghost" href="${eventUrl(event)}">Details</a>
      </div>
    </article>
  `;
}

function whatsOnSliderCard(event, index = 0) {
  const displayDate = formatEventDate(event.date);

  return `
    <article class="whats-on-card" data-category="${event.category}" data-event-index="${index}">
      <a class="whats-on-card__media" href="${eventUrl(event)}" aria-label="View ${event.title}">
        ${event.image
          ? `<img src="${assetUrl(event.image)}" alt="${event.title} poster" loading="lazy">`
          : "<span>Metro Reloaded</span>"
        }
      </a>
      <div class="whats-on-card__body">
        <span>${displayDate}</span>
        <h3><a href="${eventUrl(event)}">${event.title}</a></h3>
        <p>${event.time} · ${event.category}</p>
      </div>
      <div class="whats-on-card__footer">
        <strong>${event.price}</strong>
        <a href="${eventUrl(event)}">Details</a>
      </div>
    </article>
  `;
}

function renderEvents(sortDirection = "asc") {
  const eventGrid = document.querySelector("[data-events]");
  if (!eventGrid) return;

  const limit = Number(eventGrid.dataset.limit || events.length);
  const visibleEvents = upcomingEventsList()
    .sort((a, b) => {
      const dateSort = parseEventDate(a.date) - parseEventDate(b.date);
      return sortDirection === "desc" ? -dateSort : dateSort;
    })
    .slice(0, limit);

  eventGrid.innerHTML = visibleEvents.length
    ? visibleEvents.map(eventCard).join("")
    : "<p class=\"event-meta\">No upcoming events are available yet.</p>";
}

function clubNewsImageMarkup(article) {
  const title = escapeHtml(article.title || "Club scene news");
  const sourceId = escapeHtml(article.sourceId || "");

  if (article.image) {
    return `<img class="club-news-card__image news-card-image" src="${escapeHtml(article.image)}" alt="${title}" loading="lazy" referrerpolicy="no-referrer" data-club-news-image data-club-news-image-source="${sourceId}">`;
  }

  return clubNewsSourceFallbackMarkup(article.sourceId, article.source);
}

function clubNewsSourceFallbackMarkup(sourceId = "", sourceName = "Club news") {
  if (sourceId === "hypebot") {
    return `
      <div class="club-news-card__image news-card-image club-news-card__source-fallback club-news-card__source-fallback--hypebot" aria-label="Hypebot">
        <span>Hypebot</span>
        <strong>Music Industry News</strong>
      </div>
    `;
  }

  return `
    <div class="club-news-card__image news-card-image news-card-image--empty" aria-hidden="true">
      <span>${escapeHtml(sourceName || "Club news")}</span>
    </div>
  `;
}

function clubNewsCard(article) {
  const title = escapeHtml(article.title || "Untitled story");
  const summary = escapeHtml(article.summary || "Read the full story on the source site.");
  const source = escapeHtml(article.source || "Source");
  const sourceId = escapeHtml(article.sourceId || "");
  const url = escapeHtml(article.url || "#");
  const date = escapeHtml(formatNewsDate(article.publishedAt));

  return `
    <article class="club-news-card" data-club-news-source="${sourceId}">
      ${clubNewsImageMarkup(article)}
      <div class="club-news-card__body">
        <span>${source} · ${date}</span>
        <h3>${title}</h3>
        <p>${summary}</p>
      </div>
      <div class="club-news-card__footer">
        <a class="button button-ghost" href="${url}" data-club-news-popup rel="noopener noreferrer">Read full article</a>
      </div>
    </article>
  `;
}

function renderClubNews(filter = "all") {
  const grid = document.querySelector("[data-club-news]");
  const status = document.querySelector("[data-club-news-status]");
  if (!grid) return;

  const limit = Number(grid.dataset.limit || clubNews.length);
  const filteredNews = clubNews
    .filter((article) => filter === "all" || article.sourceId === filter)
    .sort((a, b) => parseNewsTimestamp(b.publishedAt) - parseNewsTimestamp(a.publishedAt))
    .slice(0, limit);

  if (status) {
    status.hidden = filteredNews.length > 0;
    status.textContent = clubNews.length
      ? "No stories are available for that source yet."
      : "Club scene news could not be loaded.";
  }

  grid.innerHTML = filteredNews.length
    ? filteredNews.map(clubNewsCard).join("")
    : "";

  setupClubNewsImageFallbacks(grid);
  setupClubNewsPopups(grid);
}

function setupClubNewsImageFallbacks(root = document) {
  root.querySelectorAll("[data-club-news-image]").forEach((image) => {
    if (image.dataset.metroClubNewsImageReady === "true") return;
    image.dataset.metroClubNewsImageReady = "true";

    image.addEventListener("error", () => {
      if (image.dataset.clubNewsImageSource === "hypebot") {
        const fallback = document.createElement("div");
        fallback.className = "club-news-card__image news-card-image club-news-card__source-fallback club-news-card__source-fallback--hypebot";
        fallback.setAttribute("aria-label", "Hypebot");
        fallback.innerHTML = "<span>Hypebot</span><strong>Music Industry News</strong>";
        image.replaceWith(fallback);
        return;
      }

      image.classList.add("club-news-card__image--fallback");
      image.src = window.METRO_NEWS_FALLBACK_IMAGE || assetUrl("metro-packed-dancefloor.jpg");
    }, { once: true });
  });
}

function setupClubNewsPopups(root = document) {
  root.querySelectorAll("[data-club-news-popup]").forEach((link) => {
    if (link.dataset.metroClubNewsPopupReady === "true") return;
    link.dataset.metroClubNewsPopupReady = "true";

    link.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const width = Math.min(1120, Math.max(720, Math.round(window.screen.width * 0.78)));
      const height = Math.min(820, Math.max(560, Math.round(window.screen.height * 0.82)));
      const left = Math.max(0, Math.round((window.screen.width - width) / 2));
      const top = Math.max(0, Math.round((window.screen.height - height) / 2));
      const popup = window.open(
        "about:blank",
        "metro-club-news",
        `popup=yes,scrollbars=yes,resizable=yes,width=${width},height=${height},left=${left},top=${top}`
      );

      if (!popup) return;
      popup.opener = null;
      popup.location.href = link.href;
      popup.focus();
    });
  });
}

function setupClubNewsControls() {
  const buttons = document.querySelectorAll("[data-club-news-filter]");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((item) => item.classList.remove("is-active"));
      button.classList.add("is-active");
      renderClubNews(button.dataset.clubNewsFilter || "all");
      setupImageReveals();
    });
  });
}

function renderWhatsOnSliders() {
  const sliders = document.querySelectorAll("[data-events-slider]");
  if (!sliders.length) return;

  const visibleEvents = upcomingEventsList().slice(0, 10);

  sliders.forEach((slider) => {
    slider.innerHTML = visibleEvents.length
      ? visibleEvents.map(whatsOnSliderCard).join("")
      : "<p class=\"event-meta\">No upcoming events are available yet.</p>";
  });
}

function setupWhatsOnSliders(root = document) {
  const sections = root.querySelectorAll(".whats-on-slider-section");
  if (!sections.length) return;

  sections.forEach((section) => {
    const slider = section.querySelector("[data-whats-on-slider]");
    const previous = section.querySelector("[data-whats-on-prev]");
    const next = section.querySelector("[data-whats-on-next]");
    if (!slider || slider.dataset.metroSliderReady === "true") return;

    slider.dataset.metroSliderReady = "true";
    const scrollSlider = (direction) => {
      const firstCard = slider.querySelector(".whats-on-card");
      const amount = firstCard ? firstCard.getBoundingClientRect().width + 12 : 312;
      slider.scrollBy({ left: amount * direction, behavior: "smooth" });
    };

    previous?.addEventListener("click", () => scrollSlider(-1));
    next?.addEventListener("click", () => scrollSlider(1));
  });
}

function renderFeaturedEvent() {
  const feature = document.querySelector("[data-featured-event]");
  if (!feature) return;

  const nextEvent = upcomingEventsList()[0];
  if (!nextEvent) {
    feature.innerHTML = "";
    return;
  }

  feature.innerHTML = `
    <span class="feature-label">Next Up</span>
    ${nextEvent.image ? `<a class="hero-feature__thumb" href="${eventUrl(nextEvent)}" aria-label="View ${escapeHtml(nextEvent.title)}">${posterMarkup(nextEvent)}</a>` : ""}
    <strong>${nextEvent.title}</strong>
    <span>${formatEventDate(nextEvent.date)} · ${nextEvent.time}</span>
    <a href="${eventUrl(nextEvent)}">Event details</a>
  `;
}

function renderEventDetail() {
  const detail = document.querySelector("[data-event-detail]");
  if (!detail) return;

  const params = new URLSearchParams(window.location.search);
  const requestedSlug = params.get("event");
  const event = events.find((item) => slugify(item.title) === requestedSlug) || events[0];

  if (!event) {
    detail.innerHTML = "<p>Event details could not be loaded.</p>";
    return;
  }

  document.title = `${event.title} | Metro Reloaded`;
  const heroSummary = cleanEventSummary(event.summary, event.title, 145);
  const detailSummary = cleanEventSummary(event.summary, event.title, 230);

  detail.innerHTML = `
    <section class="event-detail-hero">
      <div class="event-detail-copy">
        <p class="kicker">${event.category} · ${event.provider}</p>
        <h1>${event.title}</h1>
        <p class="hero-copy">${heroSummary}</p>
        <div class="hero-actions">
          <a class="button button-primary" href="${event.productUrl}" target="_blank" rel="noreferrer" data-metro-ticket-click data-event-title="${event.title}" data-ticket-provider="${event.provider || ""}">Buy Tickets</a>
          <a class="button button-ghost" href="/collections/forthcoming-events-at-the-metro-reloaded">All Events</a>
        </div>
      </div>
      <div class="event-detail-art">
        ${posterMarkup(event)}
      </div>
    </section>
    <section class="detail-grid">
      <article>
        <span>Date</span>
        <strong>${formatEventDate(event.date)}</strong>
      </article>
      <article>
        <span>Time</span>
        <strong>${event.time}</strong>
      </article>
      <article>
        <span>Venue</span>
        <strong>${event.venue}</strong>
      </article>
      <article>
        <span>Price</span>
        <strong>${event.price}</strong>
      </article>
    </section>
    <section class="split-section detail-section">
      <div class="split-copy">
        <p class="kicker">Event info</p>
        <h2>Plan the night</h2>
        <p>${detailSummary}</p>
        <p>Tickets are currently handled through ${event.provider}. Once Shopify API access is connected, this page can pull stock, variants, ticket tiers, and checkout links directly from the live product data.</p>
      </div>
      <div class="experience-grid">
        <article>
          <span>01</span>
          <h3>Tickets</h3>
          <p>Use the primary ticket link for the current live booking flow.</p>
        </article>
        <article>
          <span>02</span>
          <h3>Venue</h3>
          <p>Metro Reloaded, 2 Hamilton Street, Saltcoats, KA21 5EN.</p>
        </article>
        <article>
          <span>03</span>
          <h3>Entry</h3>
          <p>18+ events require valid ID. Final door policy remains with venue management.</p>
        </article>
      </div>
    </section>
  `;
}

function sortEventItems(container, direction = "asc") {
  const cards = [...container.querySelectorAll(".event-card")];
  if (!cards.length) return;

  cards
    .sort((a, b) => {
      const aDate = parseEventDate(a.dataset.eventDate);
      const bDate = parseEventDate(b.dataset.eventDate);
      const fallback = Number(a.dataset.eventIndex || 0) - Number(b.dataset.eventIndex || 0);
      const dateSort = aDate === bDate ? fallback : aDate - bDate;
      return direction === "desc" ? -dateSort : dateSort;
    })
    .forEach((card) => container.appendChild(card));

  applyEventLimit(container);
}

function applyEventLimit(container) {
  const limit = Number(container.dataset.limit || 0);
  if (!limit) return;

  const cards = [...container.querySelectorAll(".event-card:not([data-event-past='true'])")];
  cards.forEach((card, index) => {
    card.classList.toggle("is-hidden", index >= limit);
  });
}

function setupStaticEventGrids(root = document) {
  const grids = root.querySelectorAll(".event-grid:not([data-events])");
  if (!grids.length) return;

  grids.forEach((grid) => {
    const cards = [...grid.querySelectorAll(".event-card[data-event-date]")];
    if (!cards.length) return;

    cards.forEach((card) => {
      const timestamp = parseEventDate(card.dataset.eventDate);
      const eventEnd = timestamp + (24 * 60 * 60 * 1000) - 1;
      const isPast = timestamp !== Number.MAX_SAFE_INTEGER && eventEnd < Date.now();

      card.dataset.eventPast = String(isPast);
      if (isPast) {
        card.classList.add("is-hidden");
        card.setAttribute("hidden", "");
      } else {
        card.removeAttribute("hidden");
      }
    });

    sortEventItems(grid, "asc");
  });

  updateStaticFeaturedEvent(root);
}

function updateStaticFeaturedEvent(root = document) {
  const feature = root.querySelector(".hero-feature");
  const firstUpcomingCard = root.querySelector(".section-events .event-card:not([data-event-past='true'])");
  if (!feature || !firstUpcomingCard) return;

  const titleLink = firstUpcomingCard.querySelector(".event-title a");
  const dateText = firstUpcomingCard.querySelector(".event-date span:first-child")?.textContent.trim();
  const timeText = firstUpcomingCard.querySelector(".event-meta")?.innerHTML.split("<br>")[0]?.replace(/<[^>]+>/g, "").trim();
  const image = firstUpcomingCard.querySelector(".event-poster");
  if (!titleLink) return;

  const detailText = [dateText, timeText].filter(Boolean).join(" · ");
  feature.innerHTML = `
    <span class="feature-label">Next Up</span>
    ${image ? `<a class="hero-feature__thumb" href="${titleLink.getAttribute("href")}" aria-label="View ${escapeHtml(titleLink.textContent.trim())}">${image.outerHTML}</a>` : ""}
    <strong>${escapeHtml(titleLink.textContent.trim())}</strong>
    <span>${escapeHtml(detailText)}</span>
    <a href="${titleLink.getAttribute("href")}">Event details</a>
  `;
}

const productPosterCache = new Map();

function copyImageAttributes(target, source) {
  ["src", "srcset", "sizes", "alt", "width", "height"].forEach((attribute) => {
    const value = source.getAttribute(attribute);
    if (value) {
      target.setAttribute(attribute, value);
    } else {
      target.removeAttribute(attribute);
    }
  });
}

async function getCurrentProductPoster(productUrl) {
  const absoluteUrl = new URL(productUrl, window.location.origin).toString();
  if (productPosterCache.has(absoluteUrl)) return productPosterCache.get(absoluteUrl);

  const posterPromise = fetch(absoluteUrl, {
    credentials: "same-origin",
    headers: { "X-Requested-With": "XMLHttpRequest" }
  })
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.querySelector(".event-detail-art .event-poster");
    })
    .catch(() => null);

  productPosterCache.set(absoluteUrl, posterPromise);
  return posterPromise;
}

async function refreshEventProductPosters(root = document) {
  const links = [...root.querySelectorAll(".event-card > a[href*='/products/'], .hero-feature__thumb[href*='/products/']")];
  if (!links.length) return;

  await Promise.all(links.map(async (link) => {
    const targetImage = link.querySelector(".event-poster");
    if (!targetImage || targetImage.dataset.metroProductPosterRefreshed === "true") return;

    const sourceImage = await getCurrentProductPoster(link.getAttribute("href"));
    if (!sourceImage) return;

    copyImageAttributes(targetImage, sourceImage);
    targetImage.dataset.metroProductPosterRefreshed = "true";
  }));

  updateStaticFeaturedEvent(root);
}

function setupEventControls() {
  const sortButtons = document.querySelectorAll("[data-event-sort]");
  sortButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const eventGrid = button.closest(".section-events")?.querySelector(".event-grid");
      sortButtons.forEach((item) => item.classList.remove("is-active"));
      button.classList.add("is-active");
      if (eventGrid?.hasAttribute("data-events")) {
        renderEvents(button.dataset.eventSort);
        setupImageReveals();
      } else if (eventGrid) {
        sortEventItems(eventGrid, button.dataset.eventSort);
        refreshEventProductPosters(button.closest(".section-events") || document);
      }
    });
  });
}

function setupNavigation() {
  if (!navToggle || !nav) return;

  const navMenus = [...nav.querySelectorAll(".nav-item--has-menu")];
  const closeNavMenus = () => navMenus.forEach((menu) => menu.removeAttribute("open"));

  navToggle.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("is-open");
    navToggle.setAttribute("aria-expanded", String(isOpen));
    if (!isOpen) closeNavMenus();
  });

  document.querySelectorAll(".site-nav a").forEach((link) => {
    link.addEventListener("click", () => {
      nav.classList.remove("is-open");
      navToggle.setAttribute("aria-expanded", "false");
      closeNavMenus();
    });
  });

  document.addEventListener("click", (event) => {
    if (nav.contains(event.target)) return;
    closeNavMenus();
  });

  nav.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeNavMenus();
    navToggle.focus();
  });
}

function setupHeader() {
  if (!header) return;

  window.addEventListener("scroll", () => {
    header.classList.toggle("is-scrolled", window.scrollY > 24);
  }, { passive: true });
}

function setupTicker() {
  if (!tickerTrack) return;
  tickerTrack.innerHTML += tickerTrack.innerHTML;
}

function setupContactForm() {
  const form = document.querySelector("[data-contact-form]");
  if (!form) return;

  const status = document.querySelector("[data-form-status]");
  const output = document.querySelector("[data-form-output]");

  form.addEventListener("submit", (event) => {
    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const data = Object.fromEntries(new FormData(form).entries());
    const submittedAt = new Date().toISOString();
    const payload = { ...data, submittedAt };

    sessionStorage.setItem("metroContactTestSubmission", JSON.stringify(payload));

    if (status) {
      status.hidden = false;
      status.textContent = "Test send complete. This prototype captured the enquiry locally.";
    }

    if (output) {
      output.hidden = false;
      output.textContent = JSON.stringify(payload, null, 2);
    }

    form.reset();
  });
}

function setupBackgroundVideos(root = document) {
  const videos = root.querySelectorAll(".hero-video, .bandaze-video");
  if (!videos.length) return;

  videos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;

    const startVideo = () => {
      const playPromise = video.play?.();
      if (playPromise?.catch) playPromise.catch(() => {});
    };

    if (video.readyState >= 2) {
      startVideo();
    } else {
      video.addEventListener("canplay", startVideo, { once: true });
    }
  });
}

setupNavigation();
setupHeader();
setupTicker();
setupContactForm();
setupBackgroundVideos();
setupSplitHeadings();
setupImageReveals();
setupShareButtons();
setupEventDateDisplays();
setupCommerceTracking();
setupEventControls();
setupStaticEventGrids();
refreshEventProductPosters();
setupWhatsOnSliders();
setupClubNewsControls();
setupClubNewsPopups();

fetch(window.METRO_EVENTS_URL || "scraped-events.json")
  .then((response) => response.json())
  .then((scrapedEvents) => {
    events = scrapedEvents;
    renderFeaturedEvent();
    renderEvents();
    renderWhatsOnSliders();
    renderEventDetail();
    setupSplitHeadings();
    setupImageReveals();
    setupShareButtons();
    setupEventDateDisplays();
    setupCommerceTracking();
    setupWhatsOnSliders();
  })
  .catch(() => {
    const eventGrid = document.querySelector("[data-events]");
    if (eventGrid) {
      eventGrid.innerHTML = "<p class=\"event-meta\">Events could not be loaded.</p>";
    }
  });

if (document.querySelector("[data-club-news]")) {
  fetch(window.METRO_CLUB_NEWS_URL || "club-scene-news.json")
    .then((response) => response.json())
    .then((payload) => {
      clubNews = Array.isArray(payload) ? payload : payload.articles || [];
      renderClubNews();
      setupImageReveals();
    })
    .catch(() => {
      const status = document.querySelector("[data-club-news-status]");
      if (status) {
        status.hidden = false;
        status.textContent = "Club scene news could not be loaded.";
      }
    });
}
